import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Button } from "../components/ui/button";
import { SEO } from "../components/SEO";
import { productGroups, products } from "../data/content";

const ProductsPage = () => {
  return (
    <div data-testid="products-page">
      <SEO path="/termekek" />
      {/* Hero */}
      <section className="relative py-8 sm:py-10 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
          <div className="w-12 h-1 bg-amber-500 mb-3" />
          <h1 className="text-2xl sm:text-3xl font-semibold text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Termékeink
          </h1>
          <p className="text-stone-300 mt-2 max-w-2xl text-sm">
            Fedezze fel prémium alumínium szerkezeteink teljes kínálatát.
          </p>
        </div>
      </section>

      {/* Products by Group */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 space-y-16">
          {productGroups.map((group) => {
            const subcatIds = group.subcategories.length > 0 ? group.subcategories : [group.id];
            const subcatProducts = subcatIds.map(id => ({ id, ...products[id] })).filter(p => p.name);

            return (
              <div key={group.id}>
                <div className="mb-8">
                  <div className="w-10 h-1 bg-amber-500 mb-4" />
                  <h2 className="text-xl sm:text-2xl font-semibold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    {group.name}
                  </h2>
                  <p className="text-slate-600 mt-2 text-sm">{group.description}</p>
                </div>
                
                <div className={`grid grid-cols-1 ${subcatProducts.length === 1 ? 'md:grid-cols-1 max-w-lg' : subcatProducts.length === 2 ? 'md:grid-cols-2' : 'md:grid-cols-3'} gap-6`}>
                  {subcatProducts.map((product) => (
                    <Link 
                      key={product.id}
                      to={`/termekek/${product.id}`}
                      className="group bg-stone-50 border border-stone-200 overflow-hidden hover:shadow-xl transition-all duration-300"
                      data-testid={`product-card-${product.id}`}
                    >
                      <div className="aspect-[4/3] overflow-hidden">
                        <img 
                          src={product.image}
                          alt={product.name}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      <div className="p-6">
                        <h3 className="text-lg font-semibold text-slate-900 mb-2 group-hover:text-amber-600 transition-colors" style={{ fontFamily: 'Outfit, sans-serif' }}>
                          {product.name}
                        </h3>
                        <p className="text-slate-600 text-sm mb-4 line-clamp-2">
                          {product.headline}
                        </p>
                        <span className="inline-flex items-center text-amber-600 font-medium text-sm">
                          Részletek
                          <ChevronRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                        </span>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 sm:py-20 bg-stone-100">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <h2 className="text-2xl sm:text-3xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Nem tudja melyiket válassza?
          </h2>
          <p className="text-slate-600 mb-8">
            Segítünk megtalálni az Ön igényeinek legmegfelelőbb megoldást. Kérjen ingyenes helyszíni felmérést!
          </p>
          <Button 
            asChild
            className="rounded-none px-10 py-6 bg-amber-600 text-white hover:bg-amber-700 font-medium text-sm tracking-wider uppercase"
          >
            <Link to="/arajanlat-keres">Ajánlatot kérek</Link>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default ProductsPage;
